import { useCallback, useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';

const pages = { home: Hero, about: About, work: Projects, skills: Skills, experience: Experience };
const readPage = () => pages[window.location.hash.slice(1)] ? window.location.hash.slice(1) : 'home';

export default function App() {
  const [page, setPage] = useState(readPage);
  const [light, setLight] = useState(false);
  const toggleTheme = useCallback(() => setLight(value => !value), []);
  useEffect(() => {
    const update = () => { setPage(readPage()); window.scrollTo(0, 0); };
    window.addEventListener('hashchange', update);
    return () => window.removeEventListener('hashchange', update);
  }, []);
  useEffect(() => {
    document.body.classList.toggle('light', light);
    document.title = `Afeez Azeez / ${page[0].toUpperCase() + page.slice(1)}`;
  }, [light, page]);
  const Page = pages[page];
  return <>
    <a className="skip" href="#content">Skip to content</a>
    <header><a className="home-link" href="#home">❯ /home/afeez<span className="cursor" /></a>
      <nav aria-label="Main navigation">{['about', 'work', 'skills', 'experience'].map(key =>
        <a key={key} href={`#${key}`} className={page === key ? 'active' : ''}
          aria-current={page === key ? 'page' : undefined}>{key[0].toUpperCase() + key.slice(1)}</a>)}
        <button onClick={toggleTheme} aria-label={`Switch to ${light ? 'dark' : 'light'} mode`}>◐</button>
      </nav></header>
    <main id="content"><Page /></main>
    <footer><span>© 2026 Afeez Azeez</span>
      <a href="mailto:azeezafeez212@gmail.com">Let’s build something ↗</a></footer>
  </>;
}
